export default __webpack_public_path__ + "static/media/landingBackground4.cb77a474.png";